import $ from 'jquery';
import { $window, $burger, $html, $body, $user, $user_d, $homeLogo, $pageUserHero, $root, $scrollArrow, $elemCopyClipboard } from './variables';
import { adjustGeoMapOnSafari, adjustHeaderBg, adjustContentBlockBg, adjustCaseBg, lazyLoadInstance } from './auxilaries';
import { checkAndRunAnimations } from './animation';

let windowwidth = $(window).width();
let lastSt = 0
let didScroll; // nav 

$window.on('resize', () => {
  windowwidth = $(window).width() || 0;

  adjustHeaderBg();
  adjustContentBlockBg();
  adjustCaseBg();
  adjustGeoMapOnSafari(windowwidth);

  let margin_top = $('.banner').height() ?? 0;
  $pageUserHero.css('margin-top', margin_top);
});

$(window).on('load', () => {
  windowwidth = $(window).width() || 0;

  adjustHeaderBg();
  adjustContentBlockBg();
  adjustCaseBg();
  adjustGeoMapOnSafari(windowwidth);

});

window.addEventListener('scroll', () => {
  didScroll = true;
});

setInterval(() => {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 200);


function hasScrolled() {
  checkAndRunAnimations();
  let $st = $(window).scrollTop() || 0;
  lastSt = $st;
}

// anchor smooth scroll
$(document).on('click', 'a[href^="#"]', function (event) {
  event.preventDefault();

  let scrollTop = 0;

  let ref = $(this).attr('href');
  if (ref !== "#scroll" && ref !== '#contact') {
    // @ts-ignore
    if ($($.attr(this, 'href')).length !== 0) {
      // @ts-ignore
      let offset = $($.attr(this, 'href')).height() / 10;
      // @ts-ignore
      scrollTop = $($.attr(this, 'href')).offset().top - offset;
    } else {
      scrollTop = 0;
    }
  }
  if (ref && ref.includes('#scroll')) {
    // @ts-ignore
    let offset = $($.attr(this, 'href')).height() ?? 0;
    scrollTop = offset;
  }
  if (ref === '#contact') {
    // @ts-ignore
    let offset = $($.attr(this, 'href')).offset().top;
    scrollTop = offset;
  }

  $root.animate({
    scrollTop: scrollTop
  }, 500, 'swing');
});

// scroll view port on blog pages if the arrow is on page 
if ($scrollArrow.length) {
  $scrollArrow.on('click', () => {

    // define the scrolling height, bit less than the complete clientHeight 
    let height = document.documentElement.clientHeight * 0.6;

    // scroll to new position
    scrollBy({
      top: height,
      left: 0,
      behavior: "smooth"
    });
  });
}

// copy url to clipboard onclick
// TODO: Only works on https protocols
if ($elemCopyClipboard.length !== 0) {
  $elemCopyClipboard.on('click', function (ev) {
    ev.preventDefault();

    // get current url 
    let url = window.location.href;

    // save url to clipboard
    navigator.clipboard.writeText(url)
      .then(data => {
        // show success message if it was successfully
        $(this).text($(this).data('copy-success'));
      }).catch(error => {
        // show error message if it wasnt successfully 
        $(this).text($(this).data('copy-error'));
      });
  });
}

lazyLoadInstance.update();